import React from 'react'
import FreeCounseling from '../../../img/FreeCounseling.png'
import guidance from '../../../img/guidance.png'
import review from '../../../img/review.png'
import chatbotSupport from '../../../img/chatbotSupport.png'
import Comparison from '../../../img/Comparison.png'

export default function Free() {
    return (
        <div className='py-6 px-10'>
            <h1 className='text-2xl md:text-5xl font-bold mb-10 text-sky-900 text-center'>Our Free Services</h1>
            <div className='grid md:grid-cols-3 grid-cols-2 gap-7'>
                <FreeServices
                    heading='Free Career Counselling'
                    img={FreeCounseling}
                />
                <FreeServices
                    heading='Comparison between different coaching institutes.'
                    img={Comparison}
                />
                <FreeServices
                    heading='College selection guidance'
                    img={guidance}
                />
                <FreeServices
                    heading="College and institute's review"
                    img={review}
                />
                <FreeServices
                    heading='24x7 chat bot Support'
                    img={chatbotSupport}
                />
                <FreeServices
                    heading='Comparison between different colleges'
                    img={Comparison}
                />
                
            </div>
        </div>
    )
}



function FreeServices(props) {
    return (
        <div className="card card-side bg-base-100 shadow-xl hover:bg-gray-100">
            <img src={props.img} className='md:w-32 w-24 my-auto' />

            <div className="card-body">
                <h2 className="card-title font-light md:text-xl text-lg my-auto" >{props.heading}</h2>
            </div>
        </div>
    )
}